// Medalhas de conquista (docs/prototipo/conquistas-cadastro.html): componente, acervo e catálogo espelhado do contrato.
import type { Medalha } from "@grindset/server/contratos";
import type { PropsMedalhaConquista } from "./MedalhaConquista";

export * from "./catalogo";
export { DESENHOS_ACERVO, desenhoDoIcone } from "./desenhos";
export { MedalhaConquista, esmalte, type PropsMedalhaConquista } from "./MedalhaConquista";

/** Props da medalha a partir do que a API devolve (`Medalha`) e do esmalte da academia. */
export function propsDaMedalha(
  m: Medalha,
  esmalteAcademia?: number,
): Pick<PropsMedalhaConquista, "estilo" | "icone" | "numero" | "legenda" | "cor" | "esmalte"> {
  return {
    estilo: m.estilo,
    icone: m.centro === "ICONE" ? m.icone : null,
    numero: m.centro === "NUMERO" ? m.numero : null,
    legenda: m.centro === "NUMERO" ? m.legenda : null,
    cor: m.cor,
    esmalte: esmalteAcademia,
  };
}
